import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ErrorLayout from '@/lib/layouts/ErrorLayout.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Error401',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ErrorLayout, {
    type: "401",
    title: _ctx.$t('platform.error.401.title'),
    message: _ctx.$t('platform.error.401.message')
  }, null, 8, ["title", "message"]))
}
}

})